module.exports = __webpack_public_path__ + "static/media/ve.93b2af8f.svg";